import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { SentNotificationOverviewComponent } from "../sent/overview/sentnotification-overview.component";
import { ModuleType } from "@enums/ModuleType";
import { ApplicationSettings } from "@services/http/settings/application-settings";
import { SettingsDataService } from "@services/http/SettingsDataService";
import { firstValueFrom } from "rxjs";
import { MicroservicePermissionService } from "@services/permissions/permissions.service";
import { MicroserviceModule } from "@enums/microservice-module.enum";
import { IncidentPermissionType } from "@enums/permissions/incident-permission-type.enum";
import { PermissionLevel } from "@enums/permissions/permission-level.enum";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { MailMessagesOverviewComponent } from "../mailmessages/overview/mailmessages-overview.component";
import { NotificationOverviewComponent } from "../notifications/overview/notification-overview.component";
import { PeriodicNotificationOverviewComponent } from "../periodic/overview/periodic-notification-overview.component";
import { IncidentSentEmailsComponent } from "@app/incident/sent-emails/incident-sent-emails.component";
import { NotificationSettingsComponent } from "../settings/notification-settings.component";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/mailmessages/i18n/scope";

@Component({
    selector: "app-mail-overview",
    templateUrl: "./notification-maintenance.component.html",
    styleUrls: ["./notification-maintenance.component.scss"],
    imports: [
        MenuSystemDirective,
        MailMessagesOverviewComponent,
        NotificationOverviewComponent,
        PeriodicNotificationOverviewComponent,
        SentNotificationOverviewComponent,
        IncidentSentEmailsComponent,
        NotificationSettingsComponent,
        TranslatePipe,
    ],
    viewProviders: [provideTranslationScope(scope)],
})
export class MailMessageComponent implements OnInit {
    permService = inject(PermissionsService);
    _settingsService = inject(SettingsDataService);
    private _msPermService = inject(MicroservicePermissionService);

    @ViewChild("sentmails") sentmails: SentNotificationOverviewComponent;
    tab: TabModel;
    moduleTypes = ModuleType;
    useIncidents: boolean = false;
    dataLoaded: boolean = false;

    async ngOnInit() {
        await this.initSettings();
    }

    private async initSettings() {
        this.useIncidents = (
            await firstValueFrom(this._settingsService.getSetting(ApplicationSettings.UseIncidents))
        ).BoolValue;
        this.dataLoaded = true;
    }

    protected hasViewEmailsDataAccess(): boolean {
        return (
            this.useIncidents &&
            this._msPermService.getPermissionLevel(
                MicroserviceModule.Incidents,
                IncidentPermissionType.ViewEmails,
            ) === PermissionLevel.Unrestricted
        );
    }
}
